"use client";

import { Button } from "@/components/ui/button";
import { Link2 } from "lucide-react";
import { toast } from "sonner";
import { trackEvent } from "@/lib/analytics";
import { BRAND } from "@/lib/brand";
import { copyToClipboard } from "@/lib/clipboard";

interface ShareArticleProps {
  title: string;
  slug: string;
}

export function ShareArticle({ title, slug }: ShareArticleProps) {
  const url = `${process.env.NEXT_PUBLIC_BASE_URL || BRAND.url}/blog/${slug}`;

  const handleTwitter = () => {
    trackEvent("blog_share", { platform: "twitter", slug });
    const text = encodeURIComponent(`${title}\n\n`);
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const handleLinkedIn = () => {
    trackEvent("blog_share", { platform: "linkedin", slug });
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const handleCopy = async () => {
    trackEvent("blog_share", { platform: "copy_link", slug });
    const result = await copyToClipboard(url);
    if (result === "failed") {
      toast.error("Couldn't copy link — copy from address bar.");
      return;
    }
    toast.success("Link copied to clipboard!");
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-sm font-medium text-foreground/50">Share:</span>
      <Button variant="outline" size="sm" onClick={handleTwitter}>
        <svg className="size-3.5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
        X
      </Button>
      <Button variant="outline" size="sm" onClick={handleLinkedIn}>
        <svg className="size-3.5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
        LinkedIn
      </Button>
      <Button variant="outline" size="sm" onClick={handleCopy}>
        <Link2 className="size-3.5" />
        Copy Link
      </Button>
    </div>
  );
}
